import axios, { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";

export const deleteExchange = async (options: AxiosRequestConfig) => {
  return await axiosInstance.delete("/exchange/keys", options);
};

export const createAlert = async (options: AxiosRequestConfig) => {
  const { data: { data } } = await axiosInstance.post(
    "alerts/price/",
    options.data,
    options,
  );

  return data;
};

export const getAlerts = async (options: AxiosRequestConfig) => {
  const { data: { data } } = await axiosInstance.get("alerts/price/", options);

  const _assets: any = [];

  for (var i = 0; i < data.length; i++) {
    _assets.push({
      symbol: data[i].symbol.toUpperCase(),
      alert_condition: data[i].alert_condition,
      price: data[i].price,
      notes: data[i].notes,
      id: data[i].id,
      exchangeKeyId: data[i].exchange_key_id,
    });
  }

  return _assets;
};

export const deleteAlerts = async (alert_id: number) => {
  return await axiosInstance.delete(`alerts/price/?alert_id=${alert_id}`);
};

export const getCourses = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("/user/courses", options);
};

export const getVimeoEmbededUrl = async (videoUrl: string) => {
  if (videoUrl) {
    const res = await axios.get(
      `https://vimeo.com/api/oembed.json?url=${videoUrl}`,
    );
    if (res.status === 200) {
      const data = res.data;
      const html = data.html;
      if (html) {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const attrs = temp?.firstElementChild?.attributes;
        if (attrs) {
          return attrs?.getNamedItem("src")?.nodeValue;
        }
      }
    }
    return null;
  } else {
    return null;
  }
};

export const updateProfile = async (data: {
  user_name?: string,
  first_name?: string,
  last_name?: string
}, options: AxiosRequestConfig) => {
  return await axiosInstance.put("/user/update-user-details/", data, options);
}